<template>
  <div style="padding: 10px; width: 100%">
    <div
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;      "
    >
      {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
    </div>
    <div>
      <b>{{ $t("WorkRegistrationForm.ProjectOverviewTitle") }}</b>
    </div>
    <div v-for="workSlip in workSlips" :key="workSlip">
      <button
        class="custom-mobile-button text-left"
        :style="workSlip.alreadyAdded ? 'background-color: #7aef7a' : ''"
        @click="addProjectActivity(workSlip)"
      >
        <b>{{ workSlip.subTaskName }}</b>
        <br />
        <span style="color:#019ee9">{{ workSlip.projectDetails }}</span>
        <br />
     
        <span v-if="workSlip.workSlipNumber.startsWith('WC')">{{ "WC: " + workSlip.description }}</span>
        <span v-else>{{ "WB: " + workSlip.description }}</span>
      </button>
    </div>
    <button
      class="custom-mobile-button text-left"
      @click="isWorkSlipEmployeeorNot()"
    >
      {{ $t("WorkRegistrationForm.OtherActivities") }}
    </button>
    <BackButton />
    <SingleButtonConfirmation 
      @confirmed="onConfirmOtherActivities"
      :question="notPlannedMessage"
      :display="showConfirmationForOtherActivities"
      :checkBoxMessage="notPlannedCheckBoxMessage"
    />
  </div>
</template>
<script>
import WorkSlipService from "../services/WorkSlipService";
import WorkDayService from "../services/WorkDayService";
import SingleButtonConfirmation from "../components/common/SingleButtonConfirmation";
import BackButton from "../components/common/BackButton";
import { isTrailerWorkslip } from "../utils";

export default {
  name: "ProjectOverview",
  components: { SingleButtonConfirmation, BackButton },
  props: {},
  workSlipService: null,
  workDayService: null,
  data() {
    return {
      workSlip: null,
      workSlips: null,
      workDate: null,
      workDay: null,
      notPlannedMessage: this.$t("WorkRegistrationForm.NotPlannedMessage"),
      notPlannedCheckBoxMessage: this.$t(
        "WorkRegistrationForm.NotPlannedCheckBoxMessage"
      ),
      showConfirmationForOtherActivities: false,
      isWorkSlipEmployee: null
    };
  },
  created() {
    this.workSlipService = new WorkSlipService();
    this.workDayService = new WorkDayService();
    this.workDate = this.$route.query.workDate;
    this.getWorkDay();
    //this.isWorkSlipEmployee = this.$route.query.isWorkSlipEmployee;
    if(this.$route.query.isWorkSlipEmployee == 'true') {
      this.isWorkSlipEmployee = true;
    } else if (this.$route.query.isWorkSlipEmployee == true) {
      this.isWorkSlipEmployee = true;
    } else {
      this.isWorkSlipEmployee = false;
    }
  },
  methods: {
    getWorkSlipOptions() {
      this.workSlipService
        .getWorkSlipOptions(this.workDate)
        .then((response) => {
          const result = response.data;
          if (result) {
            console.log(result)
            this.workSlips = result;
            this.workSlips.forEach((workSlip) => {
              if (
                this.workDay.workRegistrations.find((wr) => {
                  return (
                    wr.activityTypeId == workSlip.activityId &&
                    wr.workSlipNumber == workSlip.workSlipNumber
                  );
                })
              ) {
                workSlip.alreadyAdded = true;
              } else {
                workSlip.alreadyAdded = false;
              }
            });
          }
        })
        .catch(() => {});
    },
    isWorkSlipEmployeeorNot()
    {
      if(this.isWorkSlipEmployee == true)
      {
        this.showConfirmationForOtherActivities = true;
      }
      else {
        return this.$router.push({
        name: "add-project-activity",
        query: {
          workday: this.$route.query.workday,
          workDate: this.$route.query.workDate,
          isMidnight: this.$route.query.isMidnight,
          workDayId: this.$route.query.workDayId,
          workDayEndTime: this.$route.query.workDayEndTime,
          drivers: this.$route.query.drivers,
          otherActivities: true,
        },
      });
      }
    },
    addProjectActivity(workSlip) {
      if(isTrailerWorkslip(workSlip.elmWorkslipNumber) && workSlip.alreadyAdded){
        this.$toast.add({
          severity: "warn",
          detail: this.$t("WorkRegistrationForm.AlreadyAddedWorkslip"),
          life: 3000,
          closable: false,
        });
        return;
      }
      return this.$router.push({
        name: "add-project-activity",
        query: {
          workday: this.$route.query.workday,
          workDate: this.$route.query.workDate,
          isMidnight: this.$route.query.isMidnight,
          workDayId: this.$route.query.workDayId,
          workDayEndTime: this.$route.query.workDayEndTime,
          drivers: this.$route.query.drivers,
          workslipValue: workSlip.value,
          otherActivities: false,
          workslipId: workSlip.gildeWorkslipId,
          subTaskId: workSlip.subTaskId
        },
      });
    },
    getWorkDay() {
      this.workDayService.getWorkDay(this.workDate).then((res) => {
        this.workDay = res.data;
        this.getWorkSlipOptions();
      });
    },
    onConfirmOtherActivities(value) {
      this.showConfirmationForOtherActivities = false;
      return this.$router.push({
        name: "add-project-activity",
        query: {
          workday: this.$route.query.workday,
          workDate: this.$route.query.workDate,
          isMidnight: this.$route.query.isMidnight,
          workDayId: this.$route.query.workDayId,
          workDayEndTime: this.$route.query.workDayEndTime,
          drivers: this.$route.query.drivers,
          otherActivities: true,
          planned: value,
        },
      });
    },
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
</style>
